import React from 'react';
import ChargerCard from './ChargerCard';

const ChargerList = (props) => {
  return (
    <div>
      <h3>
        Charging point details:
      </h3>
      <ul>
        {props.chargers.map(({ AddressInfo, ID, NumberOfPoints, IsRecentlyVerified }) => {
          return (
            < ChargerCard
              AddressInfo={AddressInfo}
              key={ID}
              ID={ID}
              NumberOfPoints={NumberOfPoints}
              IsRecentlyVerified={IsRecentlyVerified}
            />
          )
        })}
      </ul>
    </div>
  );
};

export default ChargerList;